import { Button, ButtonProps } from "@mui/material";
import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

function BlueTextButton({ ...buttonProps }: ButtonProps) {
  const classes = useStyles();
  return (
    <Button className={classes.refBtn} {...buttonProps}>
      {buttonProps.children}
    </Button>
  );
}

export default BlueTextButton;

const useStyles = createUseStyles(() => ({
  refBtn: {
    color: `${theme.color.blueLight} !important`,
    fontSize: "16px !important",
    fontWeight: "bold !important",
    padding: "0 !important",
    textDecoration: "underline !important",
    textTransform: "none !important",
  },
}));
